module.exports = __webpack_public_path__ + "img/contact-cake.53543fb2.webp";